<template>
  <div>
  <Card>
      <Row>
        <i-col span="24">
          <Form :model="searchForm" ref="searchForm" inline class="server-list">
          <FormItem label="主机名">
            <Input v-model="searchForm.hostname" style="min-width: 100px" />
          </FormItem>
          <!-- <FormItem label="私有IP">
            <Input v-model="searchForm.inner_ip" style="min-width: 100px" />
          </FormItem>
          <FormItem label="公网IP">
            <Input v-model="searchForm.public_ip" style="min-width: 100px" />
          </FormItem> -->
          <FormItem label="操作系统">
            <Select v-model="searchForm.os" style="min-width:100px">
              <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getServers()">搜索</Button>
            <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            <Button type="primary" style="margin-left: 8px" @click="batchOperate">批量操作</Button>
          </FormItem>
        </Form>
        </i-col>
       </Row>
        <Row>
          <Table
            ref="table"
            size="small"
            :columns="columns"
            :data="tableData"
            :loading="table_loading"
          ></Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page :total="count" :current="page" :page-size="size" @on-change="getServers"></page>
            </div>
          </div>
        </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getConfigServer, unInstallAgent, getHostLogConfig } from '@/api/log'
export default {
  name: 'ServerList',
  components: {
    Tables
  },
  data () {
    return {
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      count: 0,
      size: 10,
      page: 1,
      latestWinVersion: '',
      latestLinuxVersion: '',
      columns: [
        {
          minWidth: 100,
          title: '主机名',
          tooltip: true,
          key: 'hostname',
          align: 'center'
        },
        {
          minWidth: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        // {
        //   minWidth: 110,
        //   title: '私有IP',
        //   align: 'center',
        //   key: 'inner_ip'
        // },
        // {
        //   minWidth: 130,
        //   title: '公网IP',
        //   align: 'center',
        //   key: 'public_ip'
        // },
        {
          minWidth: 130,
          title: '是否配置采集路径',
          align: 'center',
          key: 'log_path'
        },
        // {
        //   minWidth: 120,
        //   title: 'Agent状态',
        //   align: 'center',
        //   key: 'status',
        //   render: (h, params) => {
        //     const row = params.row
        //     const color = row.status === 0 ? 'error' : row.status === 1 ? 'success' : 'warning'
        //     const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'
        //     // 未安装， 正常， 异常
        //     return h('Tag', {
        //       props: {
        //         type: 'dot',
        //         color: color
        //       }
        //     }, text)
        //   }
        {
          title: '操作',
          width: 170,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.readConfig(params.row.hostname)
                  }
                }
              }, '查看配置')
              // h('Poptip', {
              //   props: {
              //     confirm: true,
              //     placement: 'bottom',
              //     title: '你确定要卸载Agent吗?'
              //   },
              //   on: {
              //     'on-ok': () => {
              //       this.handleDelete(params)
              //     }
              //   }
              // }, [
              //   h('Button', {
              //     props: {
              //       type: 'error',
              //       size: 'small',
              //       disabled: params.row.status !== 1
              //     }
              //   }, '卸载')
              // ])
            ])
          }
        }
      ],
      tableData: [],
      table_loading: false,
      searchForm: {
        hostname: '',
        inner_ip: '',
        public_ip: '',
        os: ''
      }
    }
  },
  methods: {
    batchOperate () {
      this.$emit('onBactchOperate')
    },
    getServers (value = 1) {
      this.page = value
      this.table_loading = true
      this.searchForm['size'] = this.size
      this.searchForm['page'] = this.page
      getConfigServer(this.searchForm).then(res => {
        this.table_loading = false
        let result = res.data
        this.tableData = result.results
        this.count = result.count
        console.log(this.tableData)
      })
    },
    searchReset () {
      this.searchForm.hostname = ''
      this.searchForm.inner_ip = ''
      this.searchForm.public_ip = ''
      this.searchForm.os = ''
    },
    handleUpdate (params) {
      console.log(params)
      if (params.row.id) {
        let ids = [params.row.id]
        let version = params.row.os === 0 ? this.latestLinuxVersion : this.latestWinVersion
        let data = { 'ids': ids, 'version': version }
        updateAgent(data).then(res => {
          if (res.data.code === 200) {
            this.getServers()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
    },
    readConfig (hostname) {
      if (hostname) {
        this.changeLoadingShow = true
        let host = hostname
        let data = { host: host }
        getHostLogConfig(data).then(res => {
          if (res.status === 200) {
            console.log(res.data)
            this.handleRender(res.data)
          } else {
            this.$Message.error('读取配置失败')
          }
          this.executeLoading = false
        }).catch(res => {
          this.executeLoading = false
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
      this.changeLoadingShow = false
    },
    handleRender (result) {
      this.$Modal.info({
        width: '750px',
        title: '配置详情',
        render: (h) => {
          // let jsonData = JSON.stringify(params.row.result, null, 4)
          return h('div', [
            // h('span', {}, params.row.result | json)
            h('pre', {
              props: {
                autosize: { minRows: 6, maxRows: 20 }
              },
              style: {
                'white-space': 'pre-wrap',
                'overflow': 'auto',
                width: '98%',
                height: '450px'
              }
            }, result)
            // h('Input', {
            //   props: {
            //     type: 'textarea',
            //     value: params.row.result,
            //     autofocus: true,
            //     placeholder: '',
            //     readonly: true,
            //     autosize: { minRows: 6, maxRows: 20 }
            //   },
            //   style: {
            //     width: '98%',
            //     height: '450px'
            //   }
            // })
          ])
        }
      })
    },
    handleDelete (params) {
      console.log(params)
      if (params.row.id) {
        let ids = [params.row.id]
        let version = params.row.os === 0 ? this.latestLinuxVersion : this.latestWinVersion
        let data = { 'ids': ids, 'version': version }
        unInstallAgent(data).then(res => {
          if (res.data.code === 200) {
            this.getServers()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行卸载！'})
      }
    }
  },
  mounted: function () {
    this.getServers()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
@media screen and (min-width:640px){
  .server-list .ivu-form-item-content{
    display: inline-block;
  }
}
@media screen and (max-width:640px){
  .server-list .ivu-form-item-content{
    margin-left:75px;
  }
  .server-list .ivu-form-item-label{
    width:75px;
  }
  .server-list .ivu-input-wrapper{
    width:100%;
  }
}
</style>
